export default {
    template: require('./endSubscriptionFinish.jade')(),
    bindings: {},
}



// WEBPACK FOOTER //
// ./src/states/endSubscription/component/endSubscriptionFinish.js